import { render } from "./honoreePaginationItem.vue?vue&type=template&id=5839ca25"
import script from "./honoreePaginationItem.vue?vue&type=script&lang=js"
export * from "./honoreePaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__